<div class="pl-page" *ngIf="!loginSuccessful">
  <div class="pl-panel-left" [style.background-image]="brand.id ? 'url(' + brand.loginImagePath + ')' : null">
    <div class="pl-badge">
      <i class="ri-group-line"></i> {{ 'stayUpdated' | translate }}
    </div>
    <div class="pl-welcome">{{ 'welcome' | translate }}</div>
    <div class="pl-title">{{ 'parentPortal' | translate:{ brandName: brand.name } }}</div>
    <div class="pl-subtitle">{{ 'parentPortalSubtitle' | translate }}</div>

    <div class="pl-feature">
      <div class="pl-feature-icon"><i class="ri-checkbox-line"></i></div>
      <div>
        <div class="pl-feature-title">{{ 'trackAttendanceAndMarks' | translate }}</div>
        <div class="pl-feature-desc">{{ 'trackAttendanceAndMarksDesc' | translate }}</div>
      </div>
    </div>
    <div class="pl-feature">
      <div class="pl-feature-icon"><i class="ri-bank-card-line"></i></div>
      <div>
        <div class="pl-feature-title">{{ 'payFeesOnline' | translate }}</div>
        <div class="pl-feature-desc">{{ 'payFeesOnlineDesc' | translate }}</div>
      </div>
    </div>
    <div class="pl-feature">
      <div class="pl-feature-icon"><i class="ri-chat-3-line"></i></div>
      <div>
        <div class="pl-feature-title">{{ 'chatWithSchool' | translate }}</div>
        <div class="pl-feature-desc">{{ 'chatWithSchoolDesc' | translate }}</div>
      </div>
    </div>

    <div class="pl-quote" *ngIf="brand.id">"{{ 'educationQuote' | translate }}"</div>
  </div>

  <div class="pl-panel-right">
    <div class="pl-topbar">
      <app-language-dropdown iconStyle="globe"></app-language-dropdown>
      <a class="pl-help-link" [href]="brand.helpUrl" target="_blank">{{ 'help' | translate }}</a>
    </div>

    <div class="pl-form-wrapper">
      <div class="pl-icon-circle"><i class="ri-group-line"></i></div>
      <h2 class="pl-form-title">{{ 'parentLogin' | translate }}</h2>
      <p class="pl-form-subtitle">{{ (loginMode === 'email' ? 'parentLoginSubtitleEmail' : 'parentLoginSubtitle') | translate }}</p>

      <ng-container>

        <div class="pl-login-mode-switch" *ngIf="!otpSent && showLoginModeSwitch">
          <button type="button" class="pl-login-mode-option" [class.active]="loginMode === 'mobile'"
            (click)="setLoginMode('mobile')">{{ 'mobileNumber' | translate }}</button>
          <button type="button" class="pl-login-mode-option" [class.active]="loginMode === 'email'"
            (click)="setLoginMode('email')">{{ 'emailId' | translate }}</button>
        </div>

        <ng-container *ngIf="!otpSent; else otpEntry">
          <ng-container *ngIf="loginMode === 'mobile'; else emailInput">
            <label class="pl-label">{{ 'registeredMobileNumber' | translate }}</label>
            <div class="pl-mobile-input-group">
              <input type="tel" id="parent-mobile-number" class="pl-mobile-input" [(ngModel)]="mobileNumber"
                placeholder="{{ 'enterMobileNumber' | translate }}" (keyup.enter)="sendOtp()" />
            </div>
          </ng-container>
          <ng-template #emailInput>
            <label class="pl-label">{{ 'registeredEmailId' | translate }}</label>
            <div class="pl-mobile-input-group">
              <input type="email" id="parent-email-id" class="pl-mobile-input" [(ngModel)]="emailId"
                placeholder="{{ 'enterYourEmailIdPlaceholder' | translate }}" (keyup.enter)="sendOtp()" />
            </div>
          </ng-template>
          <div class="pl-error-message" *ngIf="errorMessage">{{ errorMessage }}</div>

          <button type="button" class="pl-btn-primary" (click)="sendOtp()" [disabled]="otpRequestInFlight">
            <i class="ri-send-plane-fill"></i> {{ 'sendOtp' | translate }}
          </button>
          <p class="pl-hint">{{ (loginMode === 'mobile' ? 'otpHint' : 'otpHintEmail') | translate }}</p>
        </ng-container>

        <ng-template #otpEntry>
          <p class="pl-hint">
            {{ (loginMode === 'mobile' ? 'otpSentMessage' : 'otpSentMessageEmail') | translate }}
            <strong *ngIf="loginMode === 'mobile'">+{{ countryDialCode }} {{ mobileNumber }}</strong>
            <strong *ngIf="loginMode === 'email'">{{ emailId }}</strong>
          </p>

          <div class="pl-otp-inputs">
            <input *ngFor="let digit of otp; let i = index; trackBy: trackByIndex" id="parent-otp-input-{{ i }}"
              type="text" inputmode="numeric" pattern="[0-9]*" maxlength="1" class="pl-otp-input"
              [(ngModel)]="otp[i]" (keydown)="handleOtpKeydown($event, i)" (input)="handleOtpInput($event, i)"
              (paste)="handleOtpPaste($event, i)" autocomplete="one-time-code" (keyup.enter)="verifyOtp()" />
          </div>
          <div class="pl-error-message" *ngIf="otpErrorMessage">{{ otpErrorMessage }}</div>

          <button type="button" class="pl-btn-primary" (click)="verifyOtp()" [disabled]="otpVerifyInFlight">
            {{ 'verifyOtp' | translate }}
          </button>

          <p class="pl-hint">
            <button type="button" class="pl-link-btn" [disabled]="resendTimeLeft > 0" (click)="resendOtp()">
              {{ 'resendOtp' | translate }}
            </button>
            <span *ngIf="resendTimeLeft > 0"> {{ 'in' | translate }} {{ resendTimeLeft }} {{ 'sec' | translate }}</span>
          </p>

          <button type="button" class="pl-link-btn" (click)="changeMobileNumber()">
            {{ loginMode === 'mobile' ? ('changeMobileNumber' | translate) : ('changeEmailId' | translate) }}
          </button>
        </ng-template>

        <p class="pl-footer-text">{{ 'parentAccountsCreatedBySchool' | translate }}</p>
        <p class="pl-footer-text">
          {{ 'troubleLoggingIn' | translate }}
          <a [href]="brand.helpUrl" target="_blank">{{ 'contactSchoolOffice' | translate }}</a>
        </p>
      </ng-container>
    </div>
  </div>
</div>

<!-- Dashboard shell shown after a successful login — kept inside this same
     component (no routing) so the working login flow above is untouched. -->
<div class="pd-shell" *ngIf="loginSuccessful">
  <!-- Mobile-only backdrop behind the slide-in drawer — tapping it closes
       the drawer, same as tapping a nav item. Invisible/inert on desktop
       (scoped inside the same max-width:900px block as the drawer itself). -->
  <div class="pd-sidebar-backdrop" *ngIf="mobileSidebarOpen" (click)="closeMobileSidebar()"></div>

  <aside class="pd-sidebar" [class.pd-sidebar-open]="mobileSidebarOpen">
    <div class="pd-brand">
      <div class="pd-brand-logo-wrap">
        <img *ngIf="brand.id" [src]="brand.logoPath" alt="{{ brand.name }}" class="pd-brand-logo" />
      </div>
      <div>
        <div class="pd-brand-name">{{ brand.name }}</div>
        <div class="pd-brand-sub">{{ 'parentPortalShort' | translate }}</div>
      </div>
    </div>

    <div class="pd-nav-scroll">
      <div>
        <div class="pd-nav-section-title">{{ 'home' | translate }}</div>
        <div class="pd-nav-list">
          <a class="pd-nav-item" [class.active]="activeSection === 'dashboard'" (click)="showSection('dashboard')">
            <span class="pd-nav-icon"><i class="ph ph-house"></i></span> {{ 'dashboard' | translate }}
          </a>
        </div>
      </div>

      <div>
        <div class="pd-nav-section-title">{{ 'class' | translate }}</div>
        <div class="pd-nav-list">
          <a class="pd-nav-item" *ngIf="isDiaryEnabled" [class.active]="activeSection === 'diary'" (click)="showSection('diary')">
            <span class="pd-nav-icon"><i class="ph ph-notebook"></i></span> {{ 'diary' | translate }}
          </a>
          <a class="pd-nav-item" *ngIf="isAttendanceEnabled" [class.active]="activeSection === 'attendance'" (click)="showSection('attendance')">
            <span class="pd-nav-icon"><i class="ph ph-check-square"></i></span> {{ 'attendance' | translate }}
          </a>
          <a class="pd-nav-item" *ngIf="isTimetableEnabled" [class.active]="activeSection === 'timetable'" (click)="showSection('timetable')">
            <span class="pd-nav-icon"><i class="ph ph-calendar-blank"></i></span> {{ 'timetable' | translate }}
          </a>
          <a class="pd-nav-item" *ngIf="isLeaveRequestEnabled" [class.active]="activeSection === 'leaveRequest'" (click)="showSection('leaveRequest')">
            <span class="pd-nav-icon"><i class="ph ph-calendar-check"></i></span> {{ 'leaveRequest' | translate }}
          </a>
          <a class="pd-nav-item" [class.active]="activeSection === 'myTeacher'" (click)="showSection('myTeacher')">
            <span class="pd-nav-icon"><i class="ph ph-chalkboard-teacher"></i></span> {{ 'myTeachers' | translate }}
          </a>
        </div>
      </div>

      <div>
        <div class="pd-nav-section-title">{{ 'others' | translate }}</div>
        <div class="pd-nav-list">
          <a class="pd-nav-item" *ngIf="isActivityEnabled" [class.active]="activeSection === 'activity'" (click)="showSection('activity')">
            <span class="pd-nav-icon"><i class="ph ph-image"></i></span> {{ 'activity' | translate }}
          </a>
          <a class="pd-nav-item" *ngIf="isAcademicCalendarEnabled" [class.active]="activeSection === 'academicCalendar'" (click)="showSection('academicCalendar')">
            <span class="pd-nav-icon"><i class="ph ph-calendar-dots"></i></span> {{ 'academicCalendarLabel' | translate }}
          </a>
          <a class="pd-nav-item" *ngIf="isFeesEnabled" [class.active]="activeSection === 'fees'" (click)="showSection('fees')">
            <span class="pd-nav-icon"><i class="ph ph-credit-card"></i></span> {{ 'fees' | translate }}
          </a>
          <a class="pd-nav-item" *ngIf="isChatEnabled" [class.active]="activeSection === 'chat'" (click)="showSection('chat')">
            <span class="pd-nav-icon"><i class="ph ph-chat-circle-text"></i></span> {{ 'chat' | translate }}
          </a>
          <a class="pd-nav-item" *ngIf="isBroadcastEnabled" [class.active]="activeSection === 'broadcast'" (click)="showSection('broadcast')">
            <span class="pd-nav-icon"><i class="ph ph-megaphone"></i></span> {{ 'broadcast' | translate }}
          </a>
          <a class="pd-nav-item" [class.active]="activeSection === 'documentHub'" (click)="showSection('documentHub')">
            <span class="pd-nav-icon"><i class="ph ph-file-text"></i></span> {{ 'documentHub' | translate }}
          </a>
          <a class="pd-nav-item" [class.active]="activeSection === 'feedback'" (click)="showSection('feedback')">
            <span class="pd-nav-icon"><i class="ph ph-chat-centered-text"></i></span> {{ 'feedback' | translate }}
          </a>
        </div>
      </div>
    </div>
  </aside>

  <div class="pd-content">
    <div class="pd-switch-error" *ngIf="switchStudentError">{{ switchStudentError }}</div>
    <header class="pd-topbar">
      <!-- Mobile-only hamburger — the only way to reach .pd-sidebar once it's
           display:none below 900px. Hidden on desktop via the same
           max-width:900px block that hides the sidebar. -->
      <button type="button" class="pd-hamburger-btn" title="{{ 'menu' | translate }}" (click)="toggleMobileSidebar()">
        <i class="ph ph-list"></i>
      </button>

      <!-- Multi-child avatar strip: active student (large, bordered) at
           index 0, up to 2 siblings (small, clickable to switch), and a
           "+N" pill opening the full list when there are more than 3. -->
      <div class="pd-student-info" *ngIf="students.length">
        <div class="pd-student-strip">
          <button type="button" class="pd-avatar-active" [title]="studentTooltip(students[0])" (click)="openPhotoPreview()">
            <img *ngIf="currentStudentPhoto" [src]="currentStudentPhoto" alt="{{ currentStudentName }}" />
            <span *ngIf="!currentStudentPhoto">{{ studentInitial(students[0]) }}</span>
          </button>
          <button type="button" class="pd-avatar-sibling" *ngFor="let s of avatarStripStudents.slice(1)"
            [title]="studentTooltip(s)" (click)="switchStudent(studentId(s))">
            <img *ngIf="studentPhoto(s)" [src]="studentPhoto(s)" alt="" />
            <span *ngIf="!studentPhoto(s)">{{ studentInitial(s) }}</span>
          </button>
          <button type="button" class="pd-avatar-overflow" *ngIf="overflowStudentCount > 0" (click)="openAllStudentsModal()">
            +{{ overflowStudentCount }}
          </button>
        </div>
        <div class="pd-student-info-text">
          <div class="pd-student-info-name">{{ currentStudentName }}</div>
          <div class="pd-student-info-class" *ngIf="studentClassLabel(students[0])">{{ studentClassLabel(students[0]) }}</div>
          <div class="pd-student-info-school" *ngIf="studentSchoolName(students[0])" [attr.title]="studentSchoolName(students[0])">{{ studentSchoolName(students[0]) }}</div>
        </div>
      </div>

      <div class="pd-topbar-actions">
        <button class="pd-icon-btn" title="{{ 'notifications' | translate }}" [class.active]="activeSection === 'notifications'" (click)="showSection('notifications')">
          <i class="ph ph-bell"></i>
        </button>
        <app-language-dropdown iconStyle="globe"></app-language-dropdown>
        <button class="pd-icon-btn" title="{{ 'logout' | translate }}" (click)="requestLogout()">
          <i class="ph ph-sign-out"></i>
        </button>
      </div>
    </header>

    <main class="pd-main">
      <ng-container *ngIf="activeSection === 'dashboard'">
      <div class="pd-insights" *ngIf="insightsEnabled">
        <h3 class="pd-insights-title">{{ 'parentAiInsights' | translate }}</h3>

        <ng-container *ngIf="!insightsLoading; else insightsSkeleton">
          <div class="pd-insights-empty" *ngIf="!insights.length">
            <div class="pe-icon"><i class="ph ph-folder-open"></i></div>
            <div class="pe-title">{{ 'dataNotFound' | translate }}</div>
          </div>

          <div class="pd-attn" role="status" *ngIf="attentionCount > 0">
            <span class="pd-attn-icon"><i class="ph ph-warning-circle"></i></span>
            <strong>{{ 'pdItemsNeedAttention' | translate:{ count: attentionCount } }}</strong>
            <span class="pd-attn-links">
              <ng-container *ngFor="let insight of insights">
                <a *ngIf="insightStatus(insight)?.tone === 'warn'" (click)="scrollToInsight(insight.slug); $event.preventDefault()" href="#">{{ insight.name }} · {{ insightSummary(insight) }}</a>
              </ng-container>
            </span>
          </div>

          <div class="pd-insights-grid" *ngIf="insights.length">
            <article class="pd-insight-card" *ngFor="let insight of insights; trackBy: trackByInsightSlug"
              [attr.id]="'pd-insight-' + insight.slug" [ngClass]="'pd-card-' + insight.slug"
              [class.pd-insight-card-warn]="insightStatus(insight)?.tone === 'warn'" (click)="openInsight(insight)">
              <div class="pd-card-head">
                <span class="pd-insight-icon"><i [class]="insightIcon(insight.slug)"></i></span>
                <h3 class="pd-insight-name">{{ insight.name }}</h3>
                <span class="pd-status" *ngIf="insightStatus(insight) as st" [class.pd-status-good]="st.tone === 'good'"
                  [class.pd-status-warn]="st.tone === 'warn'" [class.pd-status-none]="st.tone === 'none'">{{ st.key | translate }}</span>
              </div>

              <div class="pd-card-main">
                <div class="pd-metric" *ngIf="insightMetric(insight) as m">
                  <span class="pd-metric-value" [class.pd-metric-warn]="insightStatus(insight)?.tone === 'warn'"
                    [class.pd-metric-muted]="insightStatus(insight)?.tone === 'none'"
                    [class.pd-metric-sm]="m.value.length > 14">{{ m.value }}</span>
                  <span class="pd-metric-label" *ngIf="m.label">{{ m.label }}</span>
                </div>

                <svg *ngIf="insight.slug === 'attendance_percentage_trend'" class="pd-mini-chart" viewBox="0 0 280 40">
              <defs>
                <linearGradient [attr.id]="'pdTrendFill' + insight.slug" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" class="pd-mini-area-stop-top" />
                  <stop offset="100%" class="pd-mini-area-stop-bottom" />
                </linearGradient>
              </defs>
              <line x1="8" y1="36" x2="272" y2="36" class="pd-mini-baseline" />
              <polygon [attr.points]="trendAreaPoints(insight, 280, 40)" [attr.fill]="'url(#pdTrendFill' + insight.slug + ')'" />
              <polyline [attr.points]="trendLinePoints(insight, 280, 40)" class="pd-mini-line" [class.pd-mini-line-up]="trendIsUp(insight)" />
              <circle [attr.cx]="trendEndX(280)" [attr.cy]="trendEndY(insight, 40, 280)" r="4" class="pd-mini-dot" />
              <text [attr.x]="trendEndX(280) - 8" [attr.y]="trendEndY(insight, 40, 280) - 10" class="pd-mini-end-label" text-anchor="end">
                {{ insight.value?.currentAcademicYearAttendancePercentage }}%
              </text>
            </svg>

                <div class="pd-empty" *ngIf="insight.slug === 'attendance_days_breakdown' && breakdownTotal(insight) === 0">
                  <i class="ph ph-calendar-blank"></i>
                  <strong>{{ 'pdNoAttendanceYet' | translate }}</strong>
                  <span>{{ 'pdNoAttendanceHint' | translate }}</span>
                </div>

                <div class="pd-stack" *ngIf="insight.slug === 'attendance_days_breakdown' && breakdownTotal(insight) > 0">
                  <span *ngFor="let seg of breakdownSegments(insight)" [style.width.%]="seg.pct" [style.background]="seg.color"></span>
                </div>

                <ul class="pd-bars" *ngIf="insightBars(insight) as bars">
                  <li class="pd-bar-row" *ngFor="let b of bars">
                    <span class="pd-bar-name" *ngIf="b.label">{{ b.label }}</span>
                    <span class="pd-bar-val">{{ b.value }}</span>
                    <span class="pd-bar-track"><span class="pd-bar-fill" [class.pd-bar-fill-warn]="b.tone === 'warn'" [class.pd-bar-fill-low]="b.tone === 'low'" [style.width.%]="b.pct"></span></span>
                  </li>
                </ul>

                <dl class="pd-facts" *ngIf="insightFacts(insight) as facts">
                  <div class="pd-fact" *ngFor="let f of facts"><dt>{{ f.label | translate }}</dt><dd [class.pd-fact-down]="f.down">{{ f.value }}</dd></div>
                </dl>
              </div>

              <div class="pd-card-foot">
                <div class="pd-ai-note" *ngIf="insight.value?.insightMessage">
                  <span class="pd-ai-tag"><i class="ph-fill ph-sparkle"></i> {{ 'pdAiSummary' | translate }}</span>
                  <p>{{ insight.value.insightMessage }}</p>
                </div>
                <span class="pd-card-action">{{ 'viewDetails' | translate }}</span>
              </div>
            </article>
          </div>
        </ng-container>

        <ng-template #insightsSkeleton>
          <div class="pd-insights-grid">
            <div class="pd-insight-card pd-insight-skeleton" *ngFor="let n of [1,2,3,4]"></div>
          </div>
        </ng-template>
      </div>
      </ng-container>

      <app-parent-diary *ngIf="activeSection === 'diary'" [studentId]="currentStudentId" [classId]="currentClassId"
        [studentName]="currentStudentName"></app-parent-diary>

      <app-parent-attendance *ngIf="activeSection === 'attendance'" [studentId]="currentStudentId" [classId]="currentClassId"
        [schoolId]="currentSchoolId" [academicId]="currentAcademicId"></app-parent-attendance>

      <app-parent-timetable *ngIf="activeSection === 'timetable'" [classId]="currentClassId"></app-parent-timetable>

      <app-parent-leave-request *ngIf="activeSection === 'leaveRequest'" [studentSwitchTick]="studentSwitchTick"></app-parent-leave-request>

      <app-parent-fees *ngIf="activeSection === 'fees'" [studentId]="currentStudentId" [classId]="currentClassId"
        [academicId]="currentAcademicId" [schoolId]="currentSchoolId" [studentName]="currentStudentName"
        [currencySymbol]="currentCurrencySymbol" [isSequence]="isFeeSequenceEnabled"></app-parent-fees>

      <app-parent-document-hub *ngIf="activeSection === 'documentHub'" [studentSwitchTick]="studentSwitchTick"></app-parent-document-hub>

      <app-parent-broadcast *ngIf="activeSection === 'broadcast'" [academicId]="currentAcademicId" [studentSwitchTick]="studentSwitchTick"></app-parent-broadcast>

      <app-parent-chat *ngIf="activeSection === 'chat'" [studentId]="currentStudentId" [classId]="currentClassId" [studentSwitchTick]="studentSwitchTick" [openStaffId]="chatTargetStaffId"></app-parent-chat>

      <app-parent-notifications *ngIf="activeSection === 'notifications'" [studentId]="currentStudentId" [studentSwitchTick]="studentSwitchTick" (navigate)="showSection($event)"></app-parent-notifications>

      <app-parent-my-teacher *ngIf="activeSection === 'myTeacher'" [studentSwitchTick]="studentSwitchTick" [studentName]="currentStudentName" [classLabel]="currentClassLabel" (messageTeacher)="openChatWithTeacher($event)"></app-parent-my-teacher>

      <app-parent-activity *ngIf="activeSection === 'activity'" [studentId]="currentStudentId" [classId]="currentClassId" [studentSwitchTick]="studentSwitchTick"></app-parent-activity>

      <app-parent-feedback *ngIf="activeSection === 'feedback'" [studentSwitchTick]="studentSwitchTick"></app-parent-feedback>

      <app-parent-academic-calendar *ngIf="activeSection === 'academicCalendar'" [studentId]="currentStudentId"
        [classId]="currentClassId" [studentName]="currentStudentName"></app-parent-academic-calendar>
    </main>
  </div>

  <!-- Nested inside .pd-shell (not a sibling) so it can see the CSS custom
       properties scoped there (--pd-white, --pd-heading-black, etc.) —
       moving it outside made those resolve to nothing, leaving the modal
       background transparent. -->
  <div class="pd-modal-overlay" *ngIf="selectedInsight" (click)="closeInsight()">
    <div class="pd-modal" (click)="$event.stopPropagation()">
      <button type="button" class="pd-modal-close" (click)="closeInsight()"><i class="ph ph-x"></i></button>
      <div class="pd-insight-icon"><i [class]="insightIcon(selectedInsight.slug)"></i></div>
      <h3 class="pd-modal-title">{{ selectedInsight.name }}</h3>

      <svg *ngIf="selectedInsight.slug === 'attendance_percentage_trend'" class="pd-modal-chart" viewBox="0 0 240 100">
        <defs>
          <linearGradient id="pdTrendFillModal" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" class="pd-mini-area-stop-top" />
            <stop offset="100%" class="pd-mini-area-stop-bottom" />
          </linearGradient>
        </defs>
        <line x1="14" y1="92" x2="226" y2="92" class="pd-mini-baseline" />
        <polygon [attr.points]="trendAreaPoints(selectedInsight, 240, 100)" fill="url(#pdTrendFillModal)" />
        <polyline [attr.points]="trendLinePoints(selectedInsight, 240, 100)" class="pd-mini-line" [class.pd-mini-line-up]="trendIsUp(selectedInsight)" />
        <circle [attr.cx]="trendEndX(240)" [attr.cy]="trendEndY(selectedInsight, 100, 240)" r="5" class="pd-mini-dot" />
        <text [attr.x]="trendEndX(240) - 10" [attr.y]="trendEndY(selectedInsight, 100, 240) - 14" class="pd-modal-end-label" text-anchor="end">
          {{ selectedInsight.value?.currentAcademicYearAttendancePercentage }}%
        </text>
      </svg>

      <div class="pd-modal-donut-wrap" *ngIf="selectedInsight.slug === 'attendance_days_breakdown' && donutSegments(selectedInsight).length">
        <svg class="pd-modal-donut" viewBox="0 0 40 40">
          <circle cx="20" cy="20" r="15.5" class="pd-mini-donut-track" />
          <circle *ngFor="let seg of donutSegments(selectedInsight)" cx="20" cy="20" r="15.5" fill="none"
            [attr.stroke]="seg.color" stroke-width="7" [attr.stroke-dasharray]="seg.dasharray" [attr.stroke-dashoffset]="seg.dashoffset"
            transform="rotate(-90 20 20)" />
          <text x="20" y="23" class="pd-mini-donut-label" text-anchor="middle">{{ donutPresentPercent(selectedInsight) }}%</text>
        </svg>
        <div class="pd-modal-donut-legend">
          <div class="pd-legend-row"><span class="pd-legend-dot" style="background: var(--brand-primary-color)"></span>{{ 'present' | translate }}: {{ selectedInsight.value.currentMonth.presentCount }}</div>
          <div class="pd-legend-row"><span class="pd-legend-dot" style="background: var(--secondary-primary-color)"></span>{{ 'absent' | translate }}: {{ selectedInsight.value.currentMonth.absentCount }}</div>
          <div class="pd-legend-row"><span class="pd-legend-dot" style="background: rgba(0,0,0,.35)"></span>{{ 'late' | translate }}: {{ selectedInsight.value.currentMonth.lateCount }}</div>
          <div class="pd-legend-row"><span class="pd-legend-dot" style="background: rgba(0,0,0,.15)"></span>{{ 'leave' | translate }}: {{ selectedInsight.value.currentMonth.leaveCount }}</div>
        </div>
      </div>

      <div class="pd-modal-bars" *ngIf="selectedInsight.slug === 'homework_completion_rate' && homeworkSubjectBars.length">
        <div class="pd-bar-row" *ngFor="let s of homeworkSubjectBars">
          <div class="pd-bar-label">{{ s.subject }}</div>
          <div class="pd-bar-track"><div class="pd-bar-fill" [style.width.%]="s.rate"></div></div>
          <div class="pd-bar-value">{{ s.rate }}%</div>
        </div>
      </div>

      <p class="pd-modal-summary">{{ insightSummary(selectedInsight) }}</p>
      <p class="pd-modal-message" *ngIf="selectedInsight.value?.insightMessage">{{ selectedInsight.value.insightMessage }}</p>
      <button type="button" class="pd-modal-pay-btn" *ngIf="selectedInsight.slug === 'next_fee_due' && selectedInsight.value?.state !== 'ALL_PAID' && isFeesEnabled"
        (click)="payNowForFee()">{{ 'payNow' | translate }}</button>
    </div>
  </div>

  <!-- "+N" overflow — full list of children, tapping a row switches
       (same handleSelectedStudnet() convergence point as a sibling-avatar
       tap in the strip). -->
  <div class="pd-modal-overlay" *ngIf="showAllStudentsModal" (click)="closeAllStudentsModal()">
    <div class="pd-modal pd-students-modal" (click)="$event.stopPropagation()">
      <button type="button" class="pd-modal-close" (click)="closeAllStudentsModal()"><i class="ph ph-x"></i></button>
      <h3 class="pd-modal-title">{{ 'switchStudent' | translate }}</h3>
      <div class="pd-students-list">
        <button type="button" class="pd-student-row" *ngFor="let s of students" (click)="switchStudent(studentId(s))">
          <div class="pd-student-row-avatar">
            <img *ngIf="studentPhoto(s)" [src]="studentPhoto(s)" alt="" />
            <span *ngIf="!studentPhoto(s)">{{ studentInitial(s) }}</span>
          </div>
          <div class="pd-student-row-text">
            <div class="pd-student-row-name">{{ studentName(s) }}</div>
            <div class="pd-student-row-class" *ngIf="studentClassLabel(s)">{{ studentClassLabel(s) }}</div>
          </div>
          <span class="pd-student-row-selected" *ngIf="isActiveStudent(s)">{{ 'selected' | translate }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Active-avatar tap: photo preview only, never a switch (it's already
       the selected student). -->
  <div class="pd-modal-overlay" *ngIf="showPhotoPreview" (click)="closePhotoPreview()">
    <div class="pd-photo-preview" (click)="$event.stopPropagation()">
      <button type="button" class="pd-modal-close pd-photo-preview-close" (click)="closePhotoPreview()"><i class="ph ph-x"></i></button>
      <img *ngIf="currentStudentPhoto" [src]="currentStudentPhoto" alt="{{ currentStudentName }}" />
      <div class="pd-photo-preview-fallback" *ngIf="!currentStudentPhoto">{{ studentInitial(students[0]) }}</div>
      <div class="pd-photo-preview-name">{{ currentStudentName }}</div>
    </div>
  </div>

  <!-- Logout confirmation -->
  <div class="pd-modal-overlay" *ngIf="showLogoutConfirm" (click)="cancelLogout()">
    <div class="pd-confirm-box" (click)="$event.stopPropagation()">
      <div class="pd-confirm-icon"><i class="ph ph-sign-out"></i></div>
      <div class="pd-confirm-text">{{ 'areYouSureYouWantToLogout' | translate }}</div>
      <div class="pd-confirm-actions">
        <button type="button" class="pd-confirm-cancel" (click)="cancelLogout()">{{ 'cancel' | translate }}</button>
        <button type="button" class="pd-confirm-ok" (click)="confirmLogout()">{{ 'logout' | translate }}</button>
      </div>
    </div>
  </div>
</div>
